import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { useProjectPerformance } from '../../Hooks/Features/employeeDashboard/useProjectPerformance';
import {  SkeletonContainer } from '../Loader/Loader';

const ProjectPerformance = () => {
  const { options, loader } = useProjectPerformance();

  const isNoData =
    options &&
    options.series &&
    options.series.every((item) => item.data.length === 0);

  return (
    <div className='project-performance' style={{ height: '100%' }}>
      {loader ? (
        <SkeletonContainer />
      ) : isNoData ? (
        <div className='text-center' style={{position:'relative',top:'38px'}}>
          <img src='./assets/nodata.jpg' alt='no data' style={{ width: '34%' }} />
          <p className='text-center red mt-3' style={{ fontSize: 'x-small' }}>
            Data Not Found
          </p>
        </div>
      ) : (
        <HighchartsReact
          highcharts={Highcharts}
          options={options}
          containerProps={{
            style: {
              height: 'inherit',
            },
          }}
        />
      )}
    </div>
  );
};

export default ProjectPerformance;
